import apiClient from "../../config/apiClient";


export const fetchAvailability = async (data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    // return await apiClient.post(`/public/portal?url=public/check-availability`,data,{
      return await apiClient.post(`/public/portal?url=public/check-availability/portal`,data,{
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
// hr/staffs/check-appointment-availability 
// get

// date, 
// hour:'', 
// deprtmentId